var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mx-auto w-11-12 lg_w-1-2 xxl_w-5-12 my-2 lg_my-4" },
    [
      _c(
        "div",
        {
          staticClass:
            "text-lg lg_text-2xl dark-mode_text-secondary-200 text-secondary text-center block"
        },
        [
          _vm._v("Already have an account? "),
          _c(
            "router-link",
            { staticClass: "text-primary", attrs: { to: { name: "root" } } },
            [_vm._v("Sign In")]
          )
        ],
        1
      ),
      _c("observe", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var passes = ref.passes
              return [
                _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return passes(_vm.handleSubmit)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c("form-field", {
                          staticClass: "mr-_25 w-1-2",
                          attrs: {
                            label: "First Name",
                            rules: "required|min:1",
                            value: _vm.first_name
                          },
                          on: {
                            input: function($event) {
                              return _vm.updateState(
                                _vm.register,
                                "first_name",
                                $event
                              )
                            }
                          }
                        }),
                        _c("form-field", {
                          staticClass: "ml-_25 w-1-2",
                          attrs: {
                            label: "Last Name",
                            rules: "required|min:1",
                            value: _vm.last_name
                          },
                          on: {
                            input: function($event) {
                              return _vm.updateState(
                                _vm.register,
                                "last_name",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c("form-field", {
                          staticClass: "mr-_25 w-1-2",
                          attrs: {
                            label: "Company Name",
                            rules: "required|min:2",
                            value: _vm.company_name
                          },
                          on: {
                            input: function($event) {
                              return _vm.updateState(
                                _vm.register,
                                "company_name",
                                $event
                              )
                            }
                          }
                        }),
                        _c("form-field", {
                          staticClass: "ml-_25 w-1-2",
                          attrs: {
                            label: "Company URL",
                            rules: "required|url",
                            value: _vm.company_url
                          },
                          on: {
                            input: function($event) {
                              return _vm.updateState(
                                _vm.register,
                                "company_url",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c("form-field", {
                      staticClass: "mt-1",
                      attrs: {
                        label: "Recipient",
                        rules: "required|min:1|alpha_spaces",
                        value: _vm.addressee
                      },
                      on: {
                        input: function($event) {
                          return _vm.updateState(
                            _vm.return_address,
                            "addressee",
                            $event
                          )
                        }
                      }
                    }),
                    _c("div", { staticClass: "flex" }, [
                      _c(
                        "div",
                        { staticClass: "w-2-3 mr-_25" },
                        [
                          _c("form-field", {
                            attrs: {
                              label: "Address",
                              rules: "required|min:3|max:200",
                              value: _vm.street_1
                            },
                            on: {
                              input: function($event) {
                                return _vm.updateState(
                                  _vm.return_address,
                                  "street_1",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "w-1-3 ml-_25" },
                        [
                          _c("form-field", {
                            attrs: {
                              label: "Address 2",
                              rules: "min:3|max:200",
                              value: _vm.street_2
                            },
                            on: {
                              input: function($event) {
                                return _vm.updateState(
                                  _vm.return_address,
                                  "street_2",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c("form-field", {
                          staticClass: "mr-_25 w-1-2",
                          attrs: {
                            label: "City / Town",
                            rules: "required|min:2|max:200|alpha_spaces",
                            value: _vm.city
                          },
                          on: {
                            input: function($event) {
                              return _vm.updateState(
                                _vm.return_address,
                                "city",
                                $event
                              )
                            }
                          }
                        }),
                        _c("form-field", {
                          staticClass: "ml-_25 w-1-2",
                          attrs: {
                            label: "State / Province / Region",
                            rules: "required|min:2|max:200|alpha_spaces",
                            value: _vm.province
                          },
                          on: {
                            input: function($event) {
                              return _vm.updateState(
                                _vm.return_address,
                                "province",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c("form-field", {
                          staticClass: "mr-_25 w-1-2",
                          attrs: {
                            label: "Zip / Postal Code",
                            rules: "required|min:2|max:20|alpha_dash",
                            value: _vm.postal_code
                          },
                          on: {
                            input: function($event) {
                              return _vm.updateState(
                                _vm.return_address,
                                "postal_code",
                                $event
                              )
                            }
                          }
                        }),
                        _c("form-field", {
                          staticClass: "ml-_25 w-1-2",
                          attrs: {
                            label: "Country",
                            rules: "required|min:2|max:200|alpha_spaces",
                            value: _vm.country
                          },
                          on: {
                            input: function($event) {
                              return _vm.updateState(
                                _vm.return_address,
                                "country",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c("form-field", {
                      staticClass: "mt-1",
                      attrs: {
                        label: "Email",
                        rules: "required|email",
                        value: _vm.email
                      },
                      on: {
                        input: function($event) {
                          return _vm.updateState(_vm.register, "email", $event)
                        }
                      }
                    }),
                    _c("form-field", {
                      attrs: {
                        "password-reveal": "password-reveal",
                        type: "password",
                        label: "Password",
                        rules: "required|min:6|confirmed:pass",
                        value: _vm.password
                      },
                      on: {
                        input: function($event) {
                          return _vm.updateState(
                            _vm.register,
                            "password",
                            $event
                          )
                        }
                      }
                    }),
                    _c("form-field", {
                      attrs: {
                        "password-reveal": "password-reveal",
                        type: "password",
                        label: "Password Confirmation",
                        rules: "required",
                        vid: "pass",
                        value: _vm.confirm
                      },
                      on: {
                        input: function($event) {
                          return _vm.updateState(
                            _vm.register,
                            "confirm",
                            $event
                          )
                        }
                      }
                    }),
                    _c(
                      "b-button",
                      {
                        staticClass: "mt-1_5",
                        attrs: {
                          outlined: "outlined",
                          expanded: "expanded",
                          size: "is-medium",
                          type: "is-primary",
                          "native-type": "submit"
                        }
                      },
                      [_vm._v("Sign Up")]
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }